export default __webpack_public_path__ + "static/media/2228.f493ffa1.png";